window.tarteaucitron && (window.tarteaucitron.services.gtag = {
    "key": "gtag",
    "type": "analytic",
    "name": "Google Analytics (gtag.js)",
    "uri": "https://policies.google.com/privacy",
    "needConsent": true,
    "cookies": (function () {
        var googleIdentifier = window.tarteaucitron.user.gtagUa,
            tagUaCookie = '_gat_gtag_' + googleIdentifier,
            tagGCookie = '_ga_' + googleIdentifier;

        tagUaCookie = tagUaCookie.replace(/-/g, '_');
        tagGCookie = tagGCookie.replace(/G-/g, '');

        return ['_ga', '_gat', '_gid', '__utma', '__utmb', '__utmc', '__utmt', '__utmz', tagUaCookie, tagGCookie, '_gcl_au'];
    })(),
    "js": function () {
        "use strict";
        window.dataLayer = window.dataLayer || [];
        window.tarteaucitron.addScript('https://www.googletagmanager.com/gtag/js?id=' + window.tarteaucitron.user.gtagUa, '', function () {
            window.gtag = function gtag() {
                window.dataLayer.push(arguments);
            };
            window.gtag('js', new Date());

            if (window.tarteaucitron.user.gtagCrossdomain) {
                /**
                 * https://support.google.com/analytics/answer/7476333?hl=en
                 * https://developers.google.com/analytics/devguides/collection/gtagjs/cross-domain
                 */
                window.gtag('config', window.tarteaucitron.user.gtagUa, {'anonymize_ip': true}, {linker: {domains: window.tarteaucitron.user.gtagCrossdomain,}});
            } else {
                window.gtag('config', window.tarteaucitron.user.gtagUa, {'anonymize_ip': true});
            }

            if (typeof window.tarteaucitron.user.gtagMore === 'function') {
                window.tarteaucitron.user.gtagMore();
            }
        });
    }
});
